export default "Continue from where you stopped. Review what was already completed and finish the remaining work — do not redo finished parts.\n"